"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addLanguageFormatters = void 0;
var Language_1 = require("../constants/Language");
var addLanguageFormatters = function (monaco, language, customFormatters) {
    if (!monaco || !language || !customFormatters)
        return;
    var languageSelector = language === Language_1.Language.Expression ? Language_1.Language.JavaScript : language;
    var formatter = customFormatters[language];
    if (!formatter)
        return;
    monaco.languages.registerDocumentFormattingEditProvider(languageSelector, {
        provideDocumentFormattingEdits: function (model) {
            var value = model.getValue(1);
            var formattedValue = formatter(value);
            return [
                {
                    range: model.getFullModelRange(),
                    text: formattedValue,
                },
            ];
        },
    });
    monaco.languages.registerDocumentRangeFormattingEditProvider(languageSelector, {
        provideDocumentRangeFormattingEdits: function (model, range) {
            var value = model.getValueInRange(range, 1);
            var formattedValue = formatter(value);
            return [
                {
                    range: range,
                    text: formattedValue,
                },
            ];
        },
    });
};
exports.addLanguageFormatters = addLanguageFormatters;
